// @LTG-ID: F-024
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 02_DESIGN_SYSTEM.md, 08_FEATURES.md#F-024
// @CHANGED: 2026-02 session_001
// @OWNER: web
//
// Back-to-top floating action button — bottom-right.
// Ported from /app/source_reference/Landing Page.html lines 1284-1310.
// Appears after 400px of scroll.

import { useEffect, useState } from "react";
import "./scroll-top-fab.css";

export const ScrollTopFAB = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setVisible((window.scrollY || window.pageYOffset || 0) > 400);
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const onClick = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <button
            type="button"
            onClick={onClick}
            aria-label="Scroll to top"
            data-testid="scroll-top-fab"
            className={`ltg-scroll-top ${visible ? "is-visible" : ""}`}
        >
            <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
            >
                <line x1="12" y1="19" x2="12" y2="5" />
                <polyline points="5 12 12 5 19 12" />
            </svg>
        </button>
    );
};

export default ScrollTopFAB;
